import React from "react";
import './elo-list.scss';
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";
import CwContentViewer from "../common/cw-content-viewer/cw-content-viewer";
import SchoolApi from '../../apis/school';
import PaginationComponent from "../common/cw-pagination/cw-pagination-v2";
import ReactTooltip from 'react-tooltip';
import Dropdown from '../common/dropdown-v2/dropdown';
import MasterDataApi from "../../apis/master-data";
import CouponPI from "../../apis/coupons";
import Loading from "../common/loading/loading";
import ChapterListFilter from "./chapter-list-filter/chapter-list-filter";
import Path from "../routes/routes-path";
import SharedProfile from "../../../shared-storage/profile";
import WorkflowExperience from "../workflow/workflow-experience-for-single-elo";


class EloList extends React.Component {
    currentPage = 1
    limit = 10
    filter = {}

    alphabetHash = {}

    state = {
        reloadDropdown: false,
        showAssessmentFilterModal: false,
        selectedMasterDataId: '5e71c0afe6a6150727ddc842',
        showDropdown: false,
        dropDownList: [],
        conceptsInfo: [],
        selectedConceptInfo: [],
        showVideoDetail: false,
        eloInfo: {},
        selectedConceptIndex: -1,
        selectedVideoIndex: -1,
        chapterIntroductionVideo: [],
        comprehensionKeywordList: [
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // }
        ],
        search: '',
        seletedAlphabet: "",
        selectedAlphabetIndex: -1,
        showKeywordDetailScreen: false,
        selectedKeyword: "",
        selectedKeywordIndex: -1,
        selectedClass: "",
        isLoading: false
    }

    constructor(props) {
        super(props)
        this.userInfo = SharedProfile.getProfile()
        this.getAllClassElos({})
        this.getChapters({})

    }


    componentDidMount() {
        this.getClasses()

    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                console.log(school)
                let classes = [], boards = [], classNames = [];

                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }


                let board = ''
                if (boards.length) {
                    board = boards[0].value
                }


                classNames = classes.map(c => c.value)

                // if (!this.props.delegate?.props?.location?.state) {
                //     this.getSections({ board, class: classNames })
                // }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }

                console.log(classes)

                this.setState({ classDropdownItems: classes }, () => {
                    this.reloadDropdown()
                })
            }).catch(err => {
                console.log(err)
            })
    }

    getAllClassElos(payload) {

        // if (!payload.class) {
        //     payload.class = "Class 6"
        // }

        if (!payload.class) {
            payload.class = this.userInfo.class
        }

        this.setState({ isLoading: true })


        MasterDataApi.getAllClassElos(payload).then(allElosData => {
            console.log(allElosData)

            this.setState({
                conceptsInfo: allElosData.chapter,
                allClassEloList: allElosData.allClassEloList,
                isLoading: false
            })

        }).catch(err => {
            this.setState({ isLoading: false })
            console.log(err)
        })
    }

    getChapters(payload = {}) {

        console.log(payload)

        this.setState({ selectedClass: payload.class, selectedBoard: "CBSE" })

        // if (!payload.class) payload.class = this.state.selectedClass
        // if (!payload.board) payload.board = this.state.selectedBoard

        MasterDataApi.getAllClassChapterList(payload)
            .then(response => {
                let chapters = [], concepts = []
                response = response.data
                console.log(response)
                // this.setState({ masterDataId: response._id })

                for (let i = 0; i < response.length; i++) {
                    for (let j = 0; j < response[i].chapters.length; j++) {
                        let chapter = response[i].chapters[j]
                        chapters.push({
                            title: chapter.title,
                            value: chapter.key,
                            displayTitle: chapter.title,
                            chapterImageURL: chapter.imageUrl,
                            class: response[i].class,
                            masterDataId: response[i]._id
                        })

                        for (let k = 0; k < chapter.concepts?.length; k++) {
                            let concept = chapter.concepts[k]
                            concepts.push({
                                title: concept.title,
                                displayTitle: concept.title,
                                value: concept.key,
                                chapterKey: chapter.key,
                                chapterTitle: chapter.title,
                                masterDataId: response[i]._id,
                                order: j + 1
                            })
                            // this.buildElosDropdown(concept)
                        }

                        // this.conceptHash[chapter.key] = concepts
                    }
                }

                // chapters.push({value:'ALL',title:'ALL'})
                // console.log(chapters)
                // console.log(concepts)

                let masterDataHash = {}

                chapters.forEach(chapter => {

                    if (!masterDataHash[chapter.masterDataId]) {
                        masterDataHash[chapter.masterDataId] = [chapter]
                    } else {
                        masterDataHash[chapter.masterDataId].push(chapter)
                    }

                })

                console.log(masterDataHash)

                this.setState({
                    chapterList: chapters,
                    orginalChapterList: chapters,
                    selectedChapter: "",
                    conceptsList: concepts,
                    orginalConceptsList: concepts,
                    masterDataHash
                })
                this.reloadDropdown()
            }).catch(err => {

                if (err.response && err.response.status === 400) {
                    this.setState({ chapterList: [] })
                }
            })
    }


    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    onSelectDropDown = (option, key, cb) => {
        console.log(option)
        this.setState({ [key]: option?.value, [`${key}Object`]: option, reloadDropdown: true }, () => {

            this.setState({ reloadDropdown: false })

            if (cb) cb()
            if (key == "selectedClass" || key == "selectedBoard") {
                console.log(this.state.selectedBoard)
                // this.getSections()

                let payload = {}

                if (this.state.selectedClass) {
                    payload.class = this.state.selectedClass
                }
                this.getAllClassVideoContent(payload)
                // this.getChapters({ class: this.state.selectedClass })
            }
        })
    }




    videoEnded(chapterKey, chapterTitle, content, subType, type) {

        console.log(content)

        if (this.watchedVideoRewardAddedList[`${chapterKey}_${content._id}`]) {
            // console.log('returned')
            return;
        }

        let payload = {
            type: type,
            subType: subType,
            chapterKey,
            chapterTitle: this.state.chapterTitle,
            contentTitle: chapterTitle,
            contentId: content._id,
            board: this.state.selectedBoard,
            class: this.state.selectedClass
        }

        CouponPI.addVideoWatchedRewardPoint(payload).then((res) => {
            if (res.data.rewardPointAdded && res.data.chapterKey) {
                this.watchedVideoRewardAddedList[`${res.data.chapterKey}`] = true
            }

            if (type === "CASE_STUDY_ASSIGN" || type === "CHAPTER_ACTIVITY_ASSIGN") {
                this.setState({ rewardAssigned: this.watchedVideoRewardAddedList })
            }

            this.setState({})
        }).catch(err => {
            console.log(err)
        })


    }

    onPageSelected = (selectedPage, startIndex) => {
        this.currentPage = selectedPage
        this.onPageSelected(selectedPage, startIndex)
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage })
        this.getComprehensionKeywords(this.filter, this.filter)
    }

    onChangeHandler(event, key) {
        let value = event.target.value
        this.setState({ [key]: value })
        this.changeChapterList(value)
    }

    changeChapterList(searchText) {
        // console.log(searchText)
        let originalAllClassEloList = this.state.allClassEloList

        

        let value = searchText
        // console.log(orginalChapterList)
        // console.log('1')
        if (value && value.length >= 2) {
            
            // let chapterKeys = chapterList.map(chapter => `${chapter.masterDataId}_${chapter.value}`)
            // // console.log(chapterKeys)
            // let conceptsList = orginalConceptsList.filter(option => option[`title`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(conceptsList)
            // let conceptKeys = conceptsList.map(concept => `${concept.masterDataId}_${concept.value}`)
            // // console.log(conceptKeys)
            // let contentsArray = orginalAllClassVideoContent.filter(content => content[`displayTitle`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(contentsArray)
            // let contentIds = contentsArray.map(content => content.masterDataId_EloId_ContentIdMapping)
            // // console.log(contentIds)
            // let introContentsArray = orginalllChapterIntroVideos.filter(content => content[`displayTitle`].toLowerCase().startsWith(value.toLowerCase()));
            // console.log(introContentsArray)
            // let introContentIds = introContentsArray.map(content => content.masterDataId_ChapterKey_ContentIdMapping)
            // console.log(introContentIds)

            // this.getAllClassVideoContent({
            //     chapterKey: chapterKeys,
            //     class: this.state.selectedClass,
            //     conceptKeys: conceptKeys, contentIds: contentIds, introContentIds
            // })

            // let filteredVideoList = allVideosList.filter(option => option[`title`].toLowerCase().startsWith(value.toLowerCase()))
            let filteredEloList = originalAllClassEloList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()))


            let dropDownList = []

            filteredEloList.forEach(item => {
                let existInDropDown = dropDownList.filter(listItem => listItem.title === item.title)
                if (!existInDropDown.length) {
                    dropDownList.push(item)
                }
            })
            this.setState({dropDownList: dropDownList, showDropdown: true });
        }

        if (value === '') {
            this.getAllClassElos({})
            this.setState({ showDropdown: false });
        }
    }

    onSelectCode(item) {
        this.setState({ search: item.title, showDropdown: false }, () => {
            // this.setState({ isLoginEnable: this.validateMobile(this.state.mobileNumber) })
        })

        this.showSelectedContent(item.title)
    }

    showSelectedContent(searchText) {
        // console.log(searchText)
        let orginalAllClassEloList = this.state.allClassEloList
        

        let value = searchText

        let eloList = orginalAllClassEloList.filter(option => option[`title`].toLowerCase().includes(value.toLowerCase()));
        // console.log(chapterList)
        let eloIds = eloList.map(elo => `${elo.masterDataId}_${elo._id}`)
        // console.log(chapterKeys)
        

        this.getAllClassElos({
            eloIds: eloIds
        })
        // this.setState({ chapterList: chapterList });

    }



    clearFilter = () => {

        this.setState({
            search: "",
            selectedClass: "",
            selectedAlphabetIndex: -1,
            reloadDropdown: true

        }, () => {
            this.setState({ reloadDropdown: false })
            this.onFilterGo()
        })

    }

    onFilterGo() {
        let payload = {}
        if (this.state.search) {
            payload.search = this.state.search
        }

        this.getAllClassElos(payload)

    }

    getAlphabets() {
        let alphabets = []

        for (let i = 65; i <= 90; i++) {

            let character = ""

            if (this.alphabetHash[String.fromCharCode(i)]) {
                character = <div className={`alphabet-wrapper text-center cursor-pointer
             ${this.state.selectedAlphabetIndex === i ? "selected-alphabet-bg" : ""}`}
                    onClick={() => this.setAlphabet(i)}
                >{String.fromCharCode(i)}</div>
            } else {
                character = <div className={`alphabet-wrapper text-center disabled-alphabet
                `}
                >{String.fromCharCode(i)}</div>
            }





            alphabets.push(character)
        }

        return alphabets;
    }

    setAlphabet(index) {
        this.alphabetSearch(String.fromCharCode(index))
        this.setState({ selectedAlphabetIndex: index })
    }

    alphabetSearch(alphabet) {

        let payload = {}
        if (alphabet) {
            payload.alphabetSearch = alphabet
        }

        console.log(payload)

        this.getComprehensionKeywords(payload, this.filter)
    }

    showKeywordDetail(keyword, index) {
        this.setState({ showKeywordDetailScreen: true, selectedKeyword: keyword, selectedKeywordIndex: index })
    }

    hideWorkflowExperience() {
        let id = this.state.eloInfo._id
        this.setState({ showWorkflowExperience: false, eloInfo: {} }, () => {
            const element = document.getElementById(id);
            // console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }


    showEloDetail(concept, eloContent, conceptIndex, eloIndex) {

        console.log(concept, eloContent)

        let eloInfo = {
            // ...videoContent,
            // conceptTitle: introVideo ? "Chapter Introduction Video" : concept.title,
            ...eloContent,
            eloIds : eloContent.elos[0].id,
            // chapterKey: concept.chapterKey,
            // chapterTitle: concept.chapterTitle,
            chapterImageUrl: concept.chapterImageUrl,
            class: concept.class,
        }

        this.setState({ showWorkflowExperience: true, eloInfo, selectedConceptIndex: conceptIndex, selectedEloIndex: eloIndex })
    }


    onApplyFilter = (filterPayload) => {

        this.page = 1;

        this.payload = {}

        this.selectedFilters = filterPayload;

        console.log(filterPayload)

        this.setState({ selectedMasterDataId: filterPayload.selectedMasterDataId })

        // if (filterPayload.filterType == 'CHAPTERS') {

        let chapterKeys = filterPayload.selectedItems.map(item => `${item.masterDataId}_${item.value}`)

        this.payload['chapterKey'] = chapterKeys.join(',');

        this.hideAssessmentFilterModal(() => {
            // setTimeout(() => {
            this.getAllClassVideoContent({ chapterKey: chapterKeys })
            // }, 100);

        })
        // }



        if (filterPayload.selectedItems.length > 0) {

            this.setState({ showActiveFilter: true })

        } else {

            this.setState({ showActiveFilter: false })
        }


    }

    goBack = () => {
        this.props.navigation.navigate('LateralMenu')
    }

    showAssessmentFilterModal = () => {
        this.setState({ showAssessmentFilterModal: true })
    }

    hideAssessmentFilterModal = (callback) => {
        this.setState({ showAssessmentFilterModal: false }, () => {
            callback && callback()
        })
    }

    goToHomeScreen() {
        this.props.history.push(Path.HOME)
    }

    renderBreadcrumbForChapterList = () => {
        return (
            <div className='breadcrumb ml-2 mt-2'>
                <span className="title-1 cursor-pointer" onClick={() => this.goToHomeScreen()}>{`Home >`}</span>
                <span className='pl-2 title-1'>{`ELO Search`}</span>
                {/* <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='active pl-2'>{this.getDate(this.selectedItem.createdDate)}</span> */}
            </div>
        )
    }



    

    renderSolvedExamples() {

        let serialNumber = 0

        // console.log(this.state.conceptsInfo)

        return (
            <div className="row align-items-center justify-content-center mt-5">

                {this.state.conceptsInfo && this.state.conceptsInfo.length && this.state.conceptsInfo.map((concept, conceptIndex) => (
                    <>

                        {concept.elosInConcept && concept?.elosInConcept?.length ?
                            concept?.elosInConcept?.map((eloContent, index) => (
                                <div id={eloContent._id} className='col-4 mb-3 video-learning-content-wrapper-header position-relative'>
                                    {/* <img className='blue-dimond-icon' src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} /> */}

                                    <div className='d-flex video-learning-content flex-column position-relative' >

                                        <div className=" cursor-pointer" onClick={() => this.showEloDetail(concept, eloContent, conceptIndex, index)}>
                                            <div className={`d-flex align-items-start  
                                            video-learning-content-title`}>
                                                {/* <div className='col-2 mr-2 d-flex justify-content-center align-items-center sr-no-bg '>
                                                <div className=' sr-no-bg-color'>{`${serialNumber += 1}`}</div>
                                            </div> */}
                                                <div className={`col align-self-center sr-no`}>{`${eloContent.title.length > 38 ? eloContent.title.slice(0, 38) + "..." : eloContent.title}`}</div>
                                            </div>

                                        </div>
                                        {/* <div className=" text-right d-flex flex-row"><CwContentViewer from={'video_only'} showOnlyOneVideo={true} content={eloContent.content.description}
                                            videoEnded={() => this.videoEnded(this.props.chapterKey, eloContent.displayTitle, eloContent, "ELO_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")} /></div> */}
                                        <div className="d-flex mt-2 cursor-pointer chapter-info-wrapper" onClick={() => this.showEloDetail(concept, eloContent, conceptIndex, index)} >
                                            <div><img className="chapter-image-icon" src={concept.chapterImageUrl} /></div>
                                            <div className="ml-2 d-flex flex-column">
                                                <div><span className="chapter-title">{concept.chapterTitle}</span> | {concept.class}</div>
                                                <div>{concept.title}</div>
                                            </div>
                                        </div>
                                    </div>


                                </div >
                            )) : this.state.selectedConceptInfo.length ?
                                <div>
                                    <div className='d-flex justify-content-center pb-2'>No ELO Content Found for {`${concept.title}`}</div>
                                    {/* <div className='divider'></div> */}
                                </div>
                                : ''

                        }
                    </>
                ))
                }
            </div>
        )

    }



    render() {


        if (this.state.showWorkflowExperience) {
            return <WorkflowExperience 
            delegate = {this}
            params={this.state.eloInfo} 
            back={() => this.hideWorkflowExperience()} />
        }


        return (
            <div className="all-elo-list">
                {/* <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div> */}
                {this.renderBreadcrumbForChapterList()}
                <div className="mt-4">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        {/* <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} /> */}
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.PLAY_ICON_ORANGE)} />
                            </div>
                            <div>
                                <div className="header-text">{`Expected Learning Outcomes`}</div>
                                {/* <div className=''>{this.renderBreadcrumb()}</div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4 mb-4 position-relative" onMouseEnter={ReactTooltip.rebuild}>
                    {/* {
                        this.state.selectedClass ? <img className="search-icon-size cursor-pointer" src={getImageSource(ImageConstants.SEARCH_ICON)}
                            onClick={() => this.onFilterGo()}
                            data-tip={"Search"} />
                            :
                            <></>
                    } */}


                    {/* <div className="col-lg-3 col-md-6 col-sm-12">
                        
                        {
                            !this.state.reloadDropdown ? <div>
                                <Dropdown
                                    placeholder='Select a Class'
                                    options={this.state.classDropdownItems}
                                    onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                    text={"title"}
                                    value={this.state.selectedClass}
                                />
                            </div> : <></>
                        }

                    </div> */}

                    <div className="col-8">
                        <div>
                            <input className={`cw-input-for-search`}
                                // disabled={this.state.selectedClass ? false : true}
                                value={this.state.search}
                                onChange={(event) => this.onChangeHandler(event, "search")}
                                placeholder='Search' />
                            {
                                this.state.showDropdown ?
                                    <div className="p-2 dropdown-scroll">
                                        {this.state.dropDownList.length ?
                                            this.state.dropDownList.map(dropdown => (
                                                <div className="dropdown-list cursor-pointer px-3 py-1" onClick={() => { this.onSelectCode(dropdown) }}>
                                                    <div className="row country-name cursor-pointer">
                                                        <div className="col pl-2"> {dropdown.title}</div>
                                                        {/* <div className="col text-right">  {dropdown.text}</div> */}
                                                    </div>
                                                </div>

                                            ))
                                            : <div className="text-center py-4 no-data">
                                                <label> No Records found</label>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <></>
                            }

                        </div>

                    </div>

                    {/* <div className="col-1">
                        {this.state.showActiveFilter ?
                            <img className="filter-icon-new-size cursor-pointer mt-0"
                                onClick={this.showAssessmentFilterModal}
                                src={getImageSource(ImageConstants.FILTER_ICON_ACTIVE)} />
                            :
                            <img className="filter-icon-new-size cursor-pointer"
                                onClick={this.showAssessmentFilterModal}
                                src={getImageSource(ImageConstants.FILTER_ICON_NEW)} />
                        }

                    </div> */}

                    <div className="col-1 clear-button-wrapper ml-3">
                        <div className="filter-button  d-inline-block">
                            <button className={`cw-button clear-btn`} onClick={() => this.clearFilter()} >{"CLEAR"}</button>
                        </div>
                    </div>

                </div>

                {
                    !this.state.isLoading ?
                        <div className="solved-examples-card mt-4">

                            {
                                this.state.conceptsInfo && this.state.conceptsInfo?.length ? this.renderSolvedExamples()
                                    :
                                    // <div className='d-flex justify-content-center pb-4'>No Video Content Found for this Chapter</div>
                                    <Loading />
                                // <></>
                            }

                        </div>
                        :
                        <Loading />
                }

                {
                    <div className='card-footer' style={{ backgroundColor: "transparent" }}>
                        {
                            this.state.meta?.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                        }
                    </div>
                }
                {
                    this.state.showAssessmentFilterModal ?
                        <ChapterListFilter
                            filter={this.state.orginalChapterList}
                            close={this.hideAssessmentFilterModal}
                            onSelect={this.onSelect} chapters={this.state.chapters}
                            selectedFilters={this.selectedFilters} delegate={this}
                            masterDataHash={this.state.masterDataHash}
                            selectedMasterDataId={this.state.selectedMasterDataId} />
                        : <></>
                }
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        )
    }

}

export default EloList;